// Child: CotInfo.jsx
import axios from 'axios';
import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CotInfo = ({ inspectionCotInfo, setInspectionCotInfo, urlID }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { operator = '', type = '', company = '' } = inspectionCotInfo || {};

  const submitCotInfo = async () => {
    try {
      const bodyData = {
      status: 'inspectionCotInfo',
      inspection_id: parseInt(urlID),
      operator,    // from the destructured object
      type,
      company,
       };
      const response = await axios.post(`${apiUrl}/contracts_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data[0] === 'success') {
        toast.success('COT info saved!', { position: 'top-center' });
      } else {
        console.error('Error saving COT info:', response.data);
        toast.error('Failed to save COT info.', { position: 'top-center' });
      }
    } catch (error) {
      console.error('Error saving COT info:', error);
      toast.error('Error saving COT info.', { position: 'top-center' });
    }
  };

  return (
    <div className="mb-5">
      <div className="p-3 border rounded bg-gray-50">
        <h5 className="font-bold text-gray-700 mb-2">
          Certificate of Transmission (COT) Info
        </h5>

        <label className="block text-sm mb-1 font-semibold text-gray-700">
          Operator
        </label>
        <input
          className="border p-2 w-full mb-3"
          type="text"
          value={operator}
          onChange={(e) =>
            setInspectionCotInfo((prev) => ({ ...prev, operator: e.target.value }))
          }
          placeholder="Operator number"
        />

        <label className="block text-sm mb-1 font-semibold text-gray-700">
          Type
        </label>
        <input
          className="border p-2 w-full mb-3"
          type="text"
          value={type}
          onChange={(e) =>
            setInspectionCotInfo((prev) => ({ ...prev, type: e.target.value }))
          }
          placeholder="e.g. Vista32"
        />

        <label className="block text-sm mb-1 font-semibold text-gray-700">
          Company
        </label>
        <input
          className="border p-2 w-full mb-3"
          type="text"
          value={company}
          onChange={(e) =>
            setInspectionCotInfo((prev) => ({ ...prev, company: e.target.value }))
          }
          placeholder="e.g. StateWide"
        />

        <button
          onClick={submitCotInfo}
          className="bg-indigo-600 text-white py-1 px-3 rounded text-sm"
        >
          Save COT Info
        </button>
      </div>
    </div>
  );
};

export default CotInfo;
